export default __webpack_public_path__ + "static/media/fa-brands-400.686336e9.ttf";